import { render, staticRenderFns } from "./subbrandSetupForm.vue?vue&type=template&id=d74257a8"
import script from "./subbrandSetupForm.vue?vue&type=script&lang=js"
export * from "./subbrandSetupForm.vue?vue&type=script&lang=js"
import style0 from "./subbrandSetupForm.vue?vue&type=style&index=0&id=d74257a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports